import { Button, PageHeader, Spin } from "antd";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import BreadcrumbComponent from "../../../component/BreadcrumbComponent";
import RecordPerPage from "../../../component/RecordPerPage";
import { BreadcrumbConfig } from "../../../config/BreadcrumbConfig";
import useStore from "../../../store";
import ListComponent from "./component/ListComponent";
import AddComponent from "./component/AddComponent";
import EditComponent from "./component/EditComponent";
import ViewComponent from "./component/ViewComponent";
import DeleteComponent from "./component/DeleteComponent";
import DateExtendComponent from "./component/DateExtendComponent";
import { vsmNotify } from "../../../config/messages";
import { b64toBlob } from "../../../utils/GlobalFunction";
import ImportComponent from "./component/ImportComponent";


const ManageScheme = observer((props) => {
	const [addModal, setAddModal] = useState(false);
	const [importModal, setImportModal] = useState(false);
	const [editModal, setEditModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const [viewModal, setViewModal] = useState(false);
	const [dateExtendModal, setdateExtendModal] = useState(false);
	const [exportLoading, setExportLoading] = useState(false);
	const {
		ManageSchemeStore: {
			getList,
			setEditValues,
			setViewValues,
			setDeleteValues,
			TogglepublishData,
			setPageSize,
			per_page,
			agGrid,
		},
		AUTH,
	} = useStore();

	// Open & Close  form for add new State
	const openAddModal = () => setAddModal(true);
	const closeAddModal = () => setAddModal(false);

	const openImportModal = () => setImportModal(true);
	const closeImportModal = () => setImportModal(false);

	// Open & Close  form for edit State
	const openEditModal = (data) => {
		setEditValues(data);
		setEditModal(true);
	};
	const closeEditModal = () => setEditModal(false);

	// Open & Close  form for edit State
	const openDeleteModal = (data) => {
		setDeleteValues(data);
		setDeleteModal(true);
	};
	const closeDeleteModal = () => setDeleteModal(false);

	// Open & Close  form for edit State
	const openViewModal = (data) => {
		setViewValues(data);
		setViewModal(true);
	};
	const closeViewModal = () => setViewModal(false);

	// Open & Close  form for dateExtend State
	const openDateExtendModal = (data) => {
		setEditValues(data);
		setdateExtendModal(true);
	};
	const closeDateExtendModal = () => setdateExtendModal(false);

	// Handle on switch data
	const onSwitchChange = (checked, data) => {
		handlePublish(data);
	};

	// Handle Publish and call function to active user
	const handlePublish = (data) => {
		let formdata = data;
		TogglepublishData(formdata)
			.then((data) => {
				vsmNotify.success({
					message: data.STATUS.NOTIFICATION[0],
				});
			})
			.catch(() => {
				agGrid.api.refreshCells({ force: true });
			});
	};

	const handleExportCsv = () => {
		setExportLoading(true);
		getList({ is_export: 1 })
			.then((data) => {
				const file = b64toBlob(data.list, "text/csv");
				const fileURL = URL.createObjectURL(file);
				window.open(fileURL, '_blank');
				getList({})
			})
			.catch((e) => {
				if (e.errors && e.errors.length > 0) {
					let errorMessage = e.errors[0].errors.join(", ");
					vsmNotify.error({
						message: errorMessage,
					});
				}
			}).finally(() => setExportLoading(false))
	}

	useEffect(() => {
		getList({});
	}, [getList]);

	return (
		<PageHeader
			title={BreadcrumbConfig.ManageScheme.title}
			className="tableAreaSec"
			extra={
				<BreadcrumbComponent items={BreadcrumbConfig.ManageScheme.path} />
			}
		>
			<div className="listCountNew">
				{AUTH.checkPrivileges("#6276#") && (
					<Button key="1" onClick={openImportModal}>
						Import
					</Button>
				)}
				{AUTH.checkPrivileges("#6277#") && (
					<Button key="2" onClick={handleExportCsv}>
						{exportLoading ? <Spin /> : 'Export'}
					</Button>
				)}
				{AUTH.checkPrivileges("#6255#") && (
					<Button key="3" onClick={openAddModal}>
						New
					</Button>
				)}
				<RecordPerPage
					key="4"
					style={{ width: "150px" }}
					defaultValue={per_page + " per page"}
					onChange={setPageSize}
				/>
			</div>
			<ImportComponent visible={importModal} close={closeImportModal} />
			<AddComponent visible={addModal} close={closeAddModal} />
			<EditComponent visible={editModal} close={closeEditModal} />
			<ViewComponent visible={viewModal} close={closeViewModal} />
			<DeleteComponent visible={deleteModal} close={closeDeleteModal} />
			<DateExtendComponent visible={dateExtendModal} close={closeDateExtendModal} />
			<ListComponent
				openEditModal={openEditModal}
				openDeleteModal={openDeleteModal}
				openViewModal={openViewModal}
				onSwitchChange={onSwitchChange}
				openDateExtendModal={openDateExtendModal}
			/>
		</PageHeader>
	);
});

export default ManageScheme;
